exports.default = {
  'drag_files_here_or': '拖拽文件到這裡或者',
  'click_to_upload': '點擊上傳',
  'supports_pdf_files_single_file_size_no_more_than_20m': '支持PDF文件，單個文件大小不超過20M，不支持掃描件，每次最多選擇50個文件',
  'file_upload': '文件上傳',
  'uploading': '正在上傳',
  'upload_task_completed': '上傳任務執行完畢',
  'upload_not_completed_cancel_all_ongoing_uploads': '上傳尚未完成。要取消所有正在進行的上傳嗎?',
  'tips': '提示',
  'cancel_upload': '取消上傳',
  'continue_upload': '繼續上傳',
  'executing': '執行中...',
  'upload_task_in_progress': '上傳任務進行中...',
  'each_time_select_max_files': '每次最多選擇{multiLimit}個文件，當前選擇文件數量{filesLength}',
  'file_type_error': '文件類型錯誤!',
  'upload_avatar_image_can_only_be_jpg_or_png_format': '上傳頭像圖片只能是JPG或PNG格式!',
  'upload_image_size_cannot_exceed_10m': '上傳圖片大小不能超過10M!',
  'upload_file_size_cannot_exceed_20m': '上傳文件大小不能超過20M!',
  'uploaded_tasks_total_kb': '已上傳 {uploadFiled} 個任務，共 {uploadSize} KB'
}
